import { createContext, useContext, useEffect, useState } from "react";
import { track } from "./analytics";

const CartCtx = createContext(null);
const KEY = "cc_cart";

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || { items: [], currency: "USD", coupon: "" };
    } catch {
      return { items: [], currency: "USD", coupon: "" };
    }
  });
  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(cart));
  }, [cart]);
  const add = (product, plan) => {
    setCart((c) => {
      const exists = c.items.find((i) => i.product_id === product.id && i.plan_id === plan.id);
      const items = exists
        ? c.items.map((i) => (i === exists ? { ...i, qty: i.qty + 1 } : i))
        : [...c.items, { product_id: product.id, plan_id: plan.id, qty: 1, product_name: product.name, plan_name: plan.name }];
      return { ...c, items };
    });
    track("AddToCart", { product: product.name, plan: plan.name });
  };
  const setQty = (i, qty) => setCart((c) => ({ ...c, items: c.items.map((x, idx) => (idx === i ? { ...x, qty: Math.max(1, qty) } : x)) }));
  const remove = (i) => setCart((c) => ({ ...c, items: c.items.filter((_, idx) => idx !== i) }));
  const setCurrency = (currency) => setCart((c) => ({ ...c, currency }));
  const setCoupon = (coupon) => setCart((c) => ({ ...c, coupon }));
  const clear = () => setCart((c) => ({ ...c, items: [], coupon: "" }));
  const count = cart.items.reduce((s, i) => s + i.qty, 0);
  return <CartCtx.Provider value={{ cart, add, setQty, remove, setCurrency, setCoupon, clear, count }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
